import { SharedAngular } from '@Client/@types/sharedAngular';
import angular, { IScope } from 'angular';
import { IFlowModelDeletedMessage } from '@Shared.Angular/@types/pubSub';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.runner.library', {
    url: 'library',
    templateUrl: 'Client/runner.library/runner.library.tmpl.html',
    controllerAs: '$ctrl',
    controller: [
      'pubsubService',
      'flowModelApiService',
      'APP_CONFIG',
      '$scope',
      function (
        pubsubService: SharedAngular.PubSubService,
        flowModelApiService: SharedAngular.FlowModelApiService,
        APP_CONFIG: SharedAngular.APP_CONFIG,
        $scope: IScope
      ) {
        this.subscriberId = 'runner.library.route';

        $scope.$on('$destroy', () => {
          pubsubService.unsubscribeAll(this.subscriberId);
        });

        this.fetchFlowModelTagData = async () => {
          const tags = await flowModelApiService.getUsedTagsInFlowModels();
          return tags;
        };

        this.fetchFlowModels = () => {
          // This updates the service's FlowModel cache
          // which the tab components ingest
          flowModelApiService.getFlowModels();
          if (APP_CONFIG.enableTagging) {
            this.fetchFlowModelTagData();
          }
        };
        this.fetchFlowModels();

        pubsubService.subscribe(
          'SIGNALR_FLOW_MODEL_STATUS_CHANGED',
          this.fetchFlowModels,
          this.subscriberId
        );
        pubsubService.subscribe(
          'SIGNALR_NEW_FLOW_MODEL_SAVED',
          this.fetchFlowModels,
          this.subscriberId
        );
        pubsubService.subscribe<IFlowModelDeletedMessage>(
          'SIGNALR_SETUP_FLOW_MODEL_DELETED',
          (eventName, message) => {
            flowModelApiService.removeCachedFlowModel(message.flowModelId);
          },
          this.subscriberId
        );
        pubsubService.subscribe(
          'SIGNALR_WORKFLOW_PUBLISHED',
          this.fetchFlowModels,
          this.subscriberId
        );
        pubsubService.subscribe(
          'SIGNALR_WORKFLOW_UNPUBLISHED',
          this.fetchFlowModels,
          this.subscriberId
        );
        pubsubService.subscribe(
          'SIGNALR_WORKFLOW_NAME_CHANGED',
          this.fetchFlowModels,
          this.subscriberId
        );
        pubsubService.subscribe(
          'SIGNALR_WORKFLOW_UNPUBLISHED_CHANGES',
          this.fetchFlowModels,
          this.subscriberId
        );
      }
    ],
    resolve: {
      categories: [
        'categoryApiService',
        function (categoryApiService: SharedAngular.CategoryApiService) {
          // These are preloaded so the category service will have the categories
          // cached for use in the category column filters
          return categoryApiService.getCategories();
        }
      ]
    }
  });
}
